import { TemplateConfig } from '../template-config.interface';
import {
  disneyAvailableNow,
  disneyCTV,
  disneyEspnRugbyUrbaMiniatura,
  disneySeasonality,
  disneySocialThisMonth,
  disneyRelated,
  disneySocialTop,
  disneyCast,
  disneyGrid,
  disneyBinge,
  disneyBestPlan,
  disneyEspnVS,
  disneyEspnPlayerVSPlayer
} from '../DISNEY/';

import { resumidoCarouselGenerico, resumidoCarouselManoAMano } from '../RESUMIDO';

import { GPOVALLASAutoResolution, GPOVALLASAutoResolutionBranded } from '../GPOVALLAS';

import { macroCTV, macroGIF, macroSacaTuTarjeta } from '../MACRO';

export const TEST_TEMPLATES: TemplateConfig[] = [
  // Macro
  { ...macroCTV, clientId: 'TEST' },
  { ...macroGIF, clientId: 'TEST' },
  { ...macroSacaTuTarjeta, clientId: 'TEST' },

  { ...GPOVALLASAutoResolutionBranded, clientId: 'TEST' },
  { ...GPOVALLASAutoResolution, clientId: 'TEST' },

  // Resumido
  { ...resumidoCarouselGenerico, clientId: 'TEST' },
  { ...resumidoCarouselManoAMano, clientId: 'TEST' },

  // Disney
  { ...disneyCTV, clientId: 'TEST' },
  { ...disneyAvailableNow, clientId: 'TEST' },
  { ...disneySeasonality, clientId: 'TEST' },
  { ...disneyEspnPlayerVSPlayer, clientId: 'TEST' },
  { ...disneyEspnVS, clientId: 'TEST' },
  { ...disneyEspnRugbyUrbaMiniatura, clientId: 'TEST' },

  // No disponibles
  { ...disneySocialThisMonth, clientId: 'TEST' },
  { ...disneyRelated, clientId: 'TEST' },

  { ...disneySocialTop, clientId: 'TEST' },
  { ...disneyCast, clientId: 'TEST' },
  { ...disneyGrid, clientId: 'TEST' },
  { ...disneyBinge, clientId: 'TEST' },
  { ...disneyBestPlan, clientId: 'TEST' }
];
